import React from 'react';

import highLightText from '../utils/highLightText';

const Autocomplete = ({
  large,
  developmentResults,
  predictivePlaceResults,
  value,
  onGetPlace,
}) => {
  const returnPredictiveResults = () =>
    predictivePlaceResults.map((item, index) => (
      <span
        onClick={() => onGetPlace(item)}
        className="search-box__result-item"
        key={index}
      >
        {highLightText(item.description, value)}
      </span>
    ));

  const returnDevelopmentResults = () =>
    developmentResults.map((item, index) => (
      <a href={item.link} className="search-box__result-item" key={index}>
        {highLightText(item.city, value)}, {highLightText(item.title, value)}
      </a>
    ));

  return (
    <div
      className={`search-box__results ${large && 'search-box__results--large'}`}
    >
      <div className="search-box__results-column">
        <h2 className="search-box__results-label">Locations</h2>
        {predictivePlaceResults.length >= 1 ? (
          <div className="search-box__results-list">
            {returnPredictiveResults()}
          </div>
        ) : (
          <p className="search-box__results-text">No Locations Found</p>
        )}
      </div>
      <div className="search-box__results-column">
        <h2 className="search-box__results-label">Communities</h2>
        {developmentResults.length >= 1 ? (
          <div className="search-box__results-list">
            {returnDevelopmentResults()}
          </div>
        ) : (
          <p className="search-box__results-text">
            No Communities Found Named "{value}"{' '}
          </p>
        )}
      </div>
    </div>
  );
};

export default Autocomplete;
